import { render } from "./MainInventarios.vue?vue&type=template&id=3bb2861c&scoped=true"
import script from "./MainInventarios.vue?vue&type=script&lang=js"
export * from "./MainInventarios.vue?vue&type=script&lang=js"

import "./MainInventarios.vue?vue&type=style&index=0&id=3bb2861c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\eric.aparicio\\Documents\\REPOS\\ubiku.2023-master\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bb2861c"]])

export default __exports__